import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.keys";
import _defineProperty from "E:/workspaces/shop-app/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/**
 * 首页轮播图
 */
import api from 'api/home';
import config from '$config';
import { mapGetters } from 'vuex';
import { GET_SCREEN } from '$getters';
export default {
  name: 'module-banner',
  data: function data() {
    return {
      bannerList: null
    };
  },
  computed: _objectSpread(_objectSpread({}, mapGetters({
    screen: GET_SCREEN
  })), {}, {
    fileURL: function fileURL() {
      return config.fileURL;
    }
  }),
  watch: {},
  methods: {
    toExhibition: function toExhibition() {
      this.$router.push({
        path: '/exhibitionFabrics?templateId=3',
        query: {
          goodsSearchTemplateIdList: 256
        }
      });
    },
    toAbout: function toAbout(item) {
      if (item.carouselUrl.indexOf('http') > -1) {
        this.$router.push('recommend?src=' + item.carouselUrl);
      } else {
        if (item.carouselUrl !== '') {
          // this.$router.push({ path: '/informationDetail', query: { src: item.carouselUrl } })
          this.$router.push(item.carouselUrl);
        }
      }
    },
    carouselList: function carouselList() {
      var vm = this;
      api.carouselList().then(function (res) {
        vm.bannerList = res.data;
      });
    }
  },
  mounted: function mounted() {
    this.carouselList();
  }
};